'use client'

import * as React from 'react'

// Simple color mode provider for Create React App (not Next.js)
export function ColorModeProvider({ children }) {
  const [colorMode, setColorMode] = React.useState('light');
  
  const value = React.useMemo(
    () => ({
      colorMode,
      setColorMode,
      toggleColorMode: () => setColorMode(prev => prev === 'light' ? 'dark' : 'light')
    }),
    [colorMode]
  );

  return (
    <ColorModeContext.Provider value={value}>
      {children}
    </ColorModeContext.Provider>
  );
}

const ColorModeContext = React.createContext({});

export function useColorMode() {
  const context = React.useContext(ColorModeContext);
  if (!context) {
    throw new Error('useColorMode must be used within a ColorModeProvider');
  }
  return context;
}

export function useColorModeValue(light, dark) {
  const { colorMode } = useColorMode();
  return colorMode === 'dark' ? dark : light;
}